import * as React from 'react';
import { useNavigate } from 'react-router-dom';
import { AmorgAdminToken } from '../../amorg-common';
import { changeUserPassword, getActiveUser, logout } from '../../api/adminClientApi';
import { Button } from '../../designSystem/button/Button';
import { ButtonRow } from '../../designSystem/button/ButtonRow';
import { Card } from '../../designSystem/Card';
import { Flex } from '../../designSystem/compositeComponents/FlexHelpers';
import { TextField } from '../../designSystem/formField/text/TextField';
import { SingleColumnLayout } from '../../designSystem/layouts/SingleColumnLayout';
import { LoadingPageOverlay } from '../../designSystem/LoadingPageOverlay';
import { MessageCard } from '../../designSystem/Message';
import { H1 } from '../../designSystem/typography/Heading';
import { AdminTab } from './_components/AdminTab';
import { AmorgAdminPageProvider } from './AmorgAdminPageContext';

export function AmorgAdminProfile (): JSX.Element
{
    const [loading, setLoading] = React.useState(true);
    const [errorMessage, setErrorMessage] = React.useState('');
    const [success, setSuccess] = React.useState(false);
    const [activeUser, setActiveUser] = React.useState<AmorgAdminToken>();
    const [password, setPassword] = React.useState('');

    const navigate = useNavigate();

    React.useEffect(() =>
    {
        document.title = 'Amorgy - Profil';
        const init = async () =>
        {
            setActiveUser(await getActiveUser(() => navigate(`/amorgy/login`)));
            setLoading(false);
        };
        init().catch(console.error);
    }, []);

    async function handlePasswordSave ()
    {
        if(!activeUser)
            return;
        
        setLoading(true);
        const result = await changeUserPassword(activeUser.userId, password, () => navigate(`/amorgy/login`));
        setLoading(false);

        if (result === true)
        {
            setErrorMessage('');
            logout();
            setSuccess(true);
        }
        else
            setErrorMessage('Kunne ikke gennemføre ændringen');
    }

    return (

        <AmorgAdminPageProvider>
            <LoadingPageOverlay loading={loading} />
            <SingleColumnLayout
                noDivider
                headerContainer={
                    <Flex flexDirection="column" gap={16}>
                        <AdminTab selectedTab='profile' />
                    </Flex>
                }

                contentContainer={
                    <Flex flexDirection="column" gap={16}>
                        <Card>
                            <Flex flexDirection='column' gap={16}>
                                <H1>Skift adgangskode</H1>
                                <TextField
                                    value={password}
                                    onChange={setPassword}
                                    type="password"
                                    label="adgangskode"
                                    disabled={success}
                                    validator={() => ({ valid: true })} />
                                <ButtonRow>
                                    <Button variant="filled" text='Skift adgangskode' disabled={success}
                                        onClick={handlePasswordSave} />
                                </ButtonRow>
                            </Flex>
                        </Card>
                        <MessageCard variant="warning" hide={errorMessage === ''}>{errorMessage}</MessageCard>
                        <MessageCard variant="success" hide={!success}>
                            Adgangskoden er ændret, og du er logget ud.<br />
                            Log ind her med din nye adgangskode: <a href="/amorgy/login">Link</a>
                        </MessageCard>
                    </Flex>
                } />
        </AmorgAdminPageProvider>
    );
}